import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-cream" data-id="element-65" data-mp="bjmfuaxnuwpf">
      <div className="max-w-6xl mx-auto" data-id="element-66" data-mp="bithnycrpfiw">
        <div className="text-center mb-16" data-id="element-67" data-mp="gal1zr5byp0l">
          <h2 className="text-3xl md:text-5xl font-display font-extrabold text-ink" data-id="element-68" data-mp="gcfm538s2d3m">
            What Ninja coaches who already have the system say:
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-69" data-mp="q7zfbhvyixoo">
          {extendedTestimonials.map((testimonial, index) => <motion.div key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-silver-light p-8 rounded-2xl relative flex flex-col ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-70" data-mp="ubf8u5cqchx5" data-mpi={index}>
              <Quote className="absolute top-6 right-6 text-brand/15" size={48} aria-hidden="true" data-id="element-71" data-mp="37yuviklfi843" />
              <div className="flex gap-1 text-brand mb-6" aria-hidden="true" data-id="element-72" data-mp="33z2mk6s4hzy7">
                {[...Array(5)].map((_, star) => <Star key={star} size={16} fill="currentColor" data-id="element-73" data-mp="3vq0c51z714fg" data-mpi={star} />)}
              </div>
              <p className="text-graphite italic mb-8 relative z-10 leading-relaxed flex-grow" data-id="element-74" data-mp="3rof1zoe1n48y">
                &ldquo;{testimonial.text}&rdquo;
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-75" data-mp="3mnhcsrum99xy">
                <div className="w-12 h-12 rounded-full bg-brand flex items-center justify-center text-white font-bold text-lg shrink-0" data-id="element-76" data-mp="3hr0rs6iprbp3">
                  {testimonial.initials}
                </div>
                <div data-id="element-77" data-mp="26asr6amueag2">
                  <div className="font-bold text-ink" data-id="element-78" data-mp="269hfzpr2i0ex">{testimonial.name}</div>
                  <div className="text-xs text-brand-dark" data-id="element-79" data-mp="27taonpkm4omg">{testimonial.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}